import { defineMessages } from 'react-intl-next';

export default defineMessages({
    inlineConnectorTitle: {
        defaultMessage: 'Connect your account to view help resources from {provider}.',
        description: 'inline third party auth component title',
        id: 'third-party-connectors.connectors.inline-connectors.inline-connector-title',
    },
    connectButton: {
        defaultMessage: 'Connect',
        description: 'Authentication Button Label',
        id: 'third-party-connectors.connectors.inline-connectors.connect-button',
    },
    dismissButton: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss Button Label',
        id: 'third-party-connectors.connectors.inline-connectors.dismiss-button',
    },
});
